export default "__VITE_ASSET__1837c57f__"